"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delegateEvent = void 0;
var delegateEvent = exports.delegateEvent = function delegateEvent(elem, evt, selector, handler) {
  elem.addEventListener(evt, function (event) {
    var target = event.target;
    while (target && target !== this) {
      if (target.matches(selector)) {
        handler.call(target, event);
      }
      target = target.parentNode;
    }
  });
};